import { createAction, props } from '@ngrx/store';
import { PricingInputRequest, PricingInputResponse } from '../../models/pricing-view-models';

export const loadAllPricingInputsForSearchRequest = createAction(
  '[Pricing] Load All Pricing Inputs For Search Request'
);

export const searchPricingInputsSuccess = createAction(
  '[Pricing] Search Pricing Success',
  props<{ pricingInputRequest: PricingInputRequest; pricingInputResponse: PricingInputResponse }>()
);

export const loadPricingInputsFailure = createAction(
  '[Pricing] Load Pricing Inputs Failure',
  props<{ error: Error }>()
);

export const updatePricingInputsSearchRequest = createAction(
  '[Pricing] Update Pricing Input Request',
  props<{ pricingInputRequest: PricingInputRequest }>()
)

export const clearPricingInputsSearchRequest = createAction(
  '[Pricing] Clear Pricing Search Request'
)
